import React, { createContext, useContext, FC, useState } from "react";
import { InsuranceKeyword } from "@apiModels/Insurance/InsuranceKeyword.csharp";

type KeywordsContext = {
  keywords: InsuranceKeyword[] | null;
  setKeywords: (value: InsuranceKeyword[] | null) => void;
};

const Context = createContext<KeywordsContext | null>(null);

export const InsuranceKeywordContext: FC = ({ children }) => {
  const [keywords, setKeywords] = useState<InsuranceKeyword[] | null>(null);

  const initialValue: KeywordsContext = {
    keywords,
    setKeywords,
  };

  return <Context.Provider value={initialValue}>{children}</Context.Provider>;
};

export const useInsuranceKeywords = () => {
  const context = useContext(Context);
  if (!context) {
    throw new Error("Context has not been initialized");
  }

  return context;
};
